const modKey = /Mac|iPod|iPhone|iPad/.test(navigator.platform)
  ? "metaKey"
  : "ctrlKey";
MouseEvent.prototype.modKey = function() {
  return this[modKey];
}
export default class MouseEventUtils {
  static hasModKey(e) {
    return e[modKey];
  };
}
